module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 function player(player, reverse){ 
__p+='\n	<div class="player-cell" data-player-id="'+
((__t=( player.id ))==null?'':_.escape(__t))+
'">\n		';
 if(!reverse){ 
__p+='\n			<figure>\n				<picture>\n					<source	srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n					<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'"\n					     alt="'+
((__t=( player.first_name + ' ' + player.last_name ))==null?'':_.escape(__t))+
'">\n				</picture>\n			</figure>\n		';
 } 
__p+='\n		<div class="player-info">\n			<div class="player-name">\n				<i class="icon player-status '+
((__t=( player.status ))==null?'':_.escape(__t))+
'"></i>\n				<span>'+
((__t=( player.first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( player.last_name ))==null?'':_.escape(__t))+
'</span>\n				';
 if(player.leader_class_name){ 
__p+='\n					<i class="icon player-status player-lead-status '+
((__t=( player.leader_class_name ))==null?'':_.escape(__t))+
'"></i>\n				';
 } 
__p+='\n			</div>\n			<div class="player-stats">\n				<span class="player-opponent">\n					<b>'+
((__t=( player.squad.short_name ))==null?'':_.escape(__t))+
'</b> '+
((__t=( player.opponents.symbol ))==null?'':_.escape(__t))+
' '+
((__t=( player.opponent.short_name ))==null?'':_.escape(__t))+
'\n				</span>\n				<span> | </span>\n				<span class="player-positions">'+
((__t=( player.position_names.join(', ') ))==null?'':_.escape(__t))+
'</span>\n				<br>\n				<span class="player-cost">'+
((__t=( _.currencyFormat(player.cost) ))==null?'':_.escape(__t))+
'</span>\n				<span>&nbsp;|&nbsp;</span>\n				<span class="'+
((__t=( player.cost_season_diff > 0 ? 'positive' : '' || player.cost_season_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n					'+
((__t=( _.currencyFormat(player.cost_season_diff, '$', true) ))==null?'':_.escape(__t))+
'\n				</span>\n				<span> </span>\n				(\n				<span class="'+
((__t=( player.cost_round_diff > 0 ? 'positive' : '' || player.cost_round_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n					'+
((__t=( _.currencyFormat(player.cost_round_diff, '$', true) ))==null?'':_.escape(__t))+
'\n				</span>\n				)\n			</div>\n		</div>\n		';
 if(reverse){ 
__p+='\n			<figure>\n				<picture>\n					<source	srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n					<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'"\n					     alt="'+
((__t=( player.first_name + ' ' + player.last_name ))==null?'':_.escape(__t))+
'">\n				</picture>\n			</figure>\n		';
 } 
__p+='\n	</div>\n';
 } 
__p+='\n\n<div class="modal-reverse-trade">\n	<div class="modal-reverse-trade-container">\n		<a class="modal-reverse-trade-close js-close">\n			<i class="ion-android-close"></i>\n		</a>\n		<div class="modal-reverse-trade-inner">\n			<header class="modal-reverse-trade-header">Reverse trade</header>\n			<div class="modal-reverse-trade-body trade-board">\n				<p>Trades can only be reversed if players involved have not played yet.</p>\n\n				<p>Select which trade(s) you wish to reverse</p>\n\n				';
 _.each(trades, function(trade, index){ 
__p+='\n					<div class="trade-item">\n						<h4>Trade '+
((__t=( index + 1 ))==null?'':_.escape(__t))+
'</h4>\n						<div class="trade-item-container js-select-trade '+
((__t=( selected_trades.includes(trade.id) ? 'is-selected' : '' ))==null?'':_.escape(__t))+
'" data-id="'+
((__t=( trade.id ))==null?'':_.escape(__t))+
'">\n							<div class="trade-item-player trade-item-out-player">\n								';
 player(trade.out, false) 
__p+='\n							</div>\n							<div class="trade-item-middle-icon">\n								<img src="/assets/images/trade-icon.png" alt="">\n							</div>\n							<div class="trade-item-player trade-item-in-player">\n								';
 player(trade.in, true) 
__p+='\n							</div>\n						</div>\n					</div>\n				';
 }) 
__p+='\n\n				<div class="modal-reverse-trade-btns trade-controls">\n					<button class="btn-reverse-trade js-rollback-team">Rollback Team</button>\n					<button class="btn-confirm-trade js-reverse-trade" '+
((__t=( !_.size(selected_trades) ? 'disabled' : '' ))==null?'':_.escape(__t))+
'>Reverse Trade</button>\n				</div>\n\n				<p>If no further changes have taken place you can also rollback your team to the state it was after the last round</p>\n			</div>\n		</div>\n	</div>\n</div>';
}
return __p;
};
